import { createFetcher } from '../../Common';

import { millisecondToDate, queryBuilder } from '../../utils';

import { getBaseUrl, PANEL_PREFERRED_SLOT_ENDPOINT } from '../../constants';

class PanelPreferredSlot {
  static instance = null;

  static getInstance() {
    if (!this.instance) {
      this.instance = new PanelPreferredSlot(createFetcher());
    }
    return this.instance;
  }

  constructor(fetcher) {
    this.fetcher = fetcher;
    this.endpoint = PANEL_PREFERRED_SLOT_ENDPOINT;
  }

  get base_url() {
    return getBaseUrl();
  }

  async getAll() {
    const url = `${this.base_url}${this.endpoint}`;
    const response = await this.fetcher.getData(url);
    return response?.data;
  }

  async getByFilter(reqParam) {
    const query = queryBuilder({
      'effectiveDate.fromDate': reqParam?.fromDate
        ? millisecondToDate(reqParam.fromDate)
        : undefined,
      'effectiveDate.toDate': reqParam?.toDate ? millisecondToDate(reqParam.toDate) : undefined,
      userIDs: reqParam?.userID,
    });
    const url = `${this.base_url}${this.endpoint}${query}`;
    const response = await this.fetcher.getData(url);
    return response?.data;
  }

  async create(reqBody) {
    const url = `${this.base_url}${this.endpoint}`;
    const response = await this.fetcher.postData(url, reqBody);
    return response?.data;
  }

  async update(reqBody) {
    const url = `${this.base_url}${this.endpoint}`;
    const response = await this.fetcher.putData(url, reqBody);
    return response?.data;
  }

  async remove(id) {
    const url = `${this.base_url}${this.endpoint}/${id}`;
    const response = await this.fetcher.deleteData(url);
    return response?.data;
  }
}

export const createPanelPreferredSlot = () => PanelPreferredSlot.getInstance();
